import { Box, Container, Skeleton, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import PageRoutes, { APIRoutes } from "../../../utils/constants";
import ShortContentCard from "../ShortContentCard";
import { useCallback, useState, useEffect } from "react";
import HttpService from "../../../hooks/Https-services";
import React from "react";

const LatestVideo = ({
  hasPermition,

  selectedChannel,
}: any) => {
  const navigate = useNavigate();
  const [videoList, setVideoList] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const GetClips = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await HttpService.get(
        APIRoutes.GetWhizzardsV2 +
          `?page=${1}&limit=8&channel_id=${selectedChannel || ""}`
      );
      setVideoList(response.data?.data?.wizzards);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [selectedChannel]);
  useEffect(() => {
    GetClips();
  }, [GetClips]);
  if (isLoading) {
    return (
      <Container
        maxWidth="xl"
        sx={{ position: "relative", px: "0px !important" }}
      >
        <Grid2 container spacing={2}>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
          <Grid2 xs={12} sm={12} md={6} lg={4} xl={3}>
            <Skeleton variant="rectangular" height={250} />
          </Grid2>
        </Grid2>
      </Container>
    );
  }
  return (
    <Container maxWidth="xl" sx={{ p: "8px !important" }}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 600 }}>
            Latest Videos
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
          }}
        >
          {videoList?.length === 0 && (
            <Box
              sx={{
                textAlign: "start",
                px: 3,
                height: 260,
                bgcolor: "transparent",
                display: "flex",
                borderRadius: "10px",
                border: "1px solid #E7E7E7",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  textTransform: "none",
                  fontStyle: "normal",
                  textAlign: "center",
                }}
              >
                There are no highlights right now
              </Typography>
            </Box>
          )}
          <Grid2 container spacing={2} rowSpacing={3} columnSpacing={2}>
            {videoList?.map((clip: any) => (
              <Grid2
                onClick={() => {
                  if (hasPermition()) {
                    navigate(PageRoutes.ShortView.replace(":id", clip.ID));
                  }
                }}
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
                key={clip.ID}
              >
                <ShortContentCard clip={clip} />
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box>
    </Container>
  );
};

export default LatestVideo;
